import autosize from 'autosize'

export default function () {
  autosize(document.querySelectorAll('.jsTextareaAutosize'));
}
